import { AppSwitcher_default } from './chunk-WN3RTF5O.mjs';
import { LanguageSwitcher_default } from './chunk-PASAUMN2.mjs';
import DehazeIcon from '@mui/icons-material/Dehaze';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { styled, IconButton, Drawer, Avatar, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Backdrop, CircularProgress, Typography, Collapse, useTheme, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { getAuthUrl } from '@repo/api-client';
import { jsxs, jsx } from 'react/jsx-runtime';

var useSidebarController = ({
  logout,
  authUrl: propsAuthUrl
}) => {
  const navigate = useNavigate();
  const [isWide, setIsWide] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(isMobile ? false : true);
  const [variant, setVariant] = useState(isMobile ? "temporary" : "permanent");
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isNavigatingAuth, setIsNavigatingAuth] = useState(false);
  const handleLogout = () => {
    setIsLoggingOut(true);
    logout();
    if (typeof window !== "undefined") {
      const targetUrl = (propsAuthUrl || getAuthUrl()).replace(/\/+$/, "");
      try {
        const parsed = new URL(targetUrl, window.location.origin);
        if (parsed.origin === window.location.origin) {
          window.location.href = "/?action=logout";
          return;
        }
        parsed.searchParams.set("action", "logout");
        window.location.href = parsed.toString();
        return;
      } catch {
      }
      const separator = targetUrl.includes("?") ? "&" : "?";
      window.location.href = `${targetUrl}${separator}action=logout`;
    }
  };
  const handleUserClick = () => {
    if (typeof window !== "undefined") {
      const baseAuthUrl = (propsAuthUrl || getAuthUrl()).replace(/\/+$/, "");
      try {
        const parsed = new URL(baseAuthUrl, window.location.origin);
        if (parsed.origin === window.location.origin) {
          navigate("/profile");
          return;
        }
      } catch {
      }
      setIsNavigatingAuth(true);
      window.location.href = `${baseAuthUrl}/profile`;
    }
  };
  const toggleWidth = () => {
    setIsWide(!isWide);
  };
  const showDrawer = () => {
    setVariant("persistent");
    setOpen(true);
  };
  return {
    isWide,
    theme,
    isMobile,
    open,
    setOpen,
    variant,
    isLoggingOut,
    isNavigatingAuth,
    handleLogout,
    handleUserClick,
    toggleWidth,
    showDrawer
  };
};

// src/assets/user.svg
var user_default = "./user-5XML7JCK.svg";
var ActsLogo = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ...props,
    children: [
      /* @__PURE__ */ jsx("desc", { children: "Created with Fabric.js 5.2.4" }),
      /* @__PURE__ */ jsx("defs", {}),
      /* @__PURE__ */ jsx(
        "g",
        {
          transform: "matrix(1 0 0 1 540 540)",
          id: "a2c295cc-b428-4e39-ae52-d87598fdb688"
        }
      ),
      /* @__PURE__ */ jsx(
        "g",
        {
          transform: "matrix(1 0 0 1 540 540)",
          id: "4081865a-881c-465b-9a42-ecfe5ad564a7",
          children: /* @__PURE__ */ jsx(
            "rect",
            {
              style: {
                stroke: "none",
                strokeWidth: 1,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeDashoffset: 0,
                strokeLinejoin: "miter",
                strokeMiterlimit: 4,
                fill: "rgb(255,255,255)",
                fillRule: "nonzero",
                opacity: 1,
                visibility: "hidden"
              },
              vectorEffect: "non-scaling-stroke",
              x: -540,
              y: -540,
              rx: 0,
              ry: 0,
              width: 1080,
              height: 1080
            }
          )
        }
      ),
      /* @__PURE__ */ jsx("g", { transform: "matrix(1 0 0 1 540.84 540)", children: /* @__PURE__ */ jsx(
        "rect",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(255,255,255)",
            fillRule: "nonzero",
            opacity: 1,
            visibility: "hidden"
          },
          vectorEffect: "non-scaling-stroke",
          x: -540,
          y: -540,
          rx: 0,
          ry: 0,
          width: 1080,
          height: 1080
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 617.62 376.16)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(15,117,188)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3750.12, -4366.51)",
          d: "M 2355 6073 C 2225 6065 1960 6010 1806 5959 C 1665 5913 1330 5723 1330 5690 C 1330 5684 1373 5680 1433 5680 C 1616 5680 1907 5651 2140 5609 C 2551 5537 2970 5376 3275 5175 C 3944 4733 4340 3942 4340 3046 C 4340 2854 4349 2810 4400 2748 C 4417 2728 4456 2699 4488 2683 C 4543 2656 4550 2655 4700 2655 C 4870 2656 4929 2668 5205 2758 C 5638 2900 6028 3202 6126 3470 C 6192 3651 6184 3846 6103 4040 C 5942 4425 5500 4855 4806 5300 C 4094 5756 3411 6020 2810 6070 C 2702 6079 2469 6081 2355 6073 z M 5317 4483 C 5247 4372 5207 4263 5184 4120 C 5162 3985 5173 3937 5270 3746 C 5363 3564 5386 3480 5377 3358 C 5364 3170 5245 3046 5023 2989 C 4925 2964 4895 2964 4905 2988 C 4922 3029 4922 3088 4905 3123 C 4896 3143 4851 3193 4805 3235 C 4664 3362 4627 3445 4655 3565 C 4672 3641 4711 3720 4772 3806 C 4867 3940 4902 3968 4857 3873 C 4827 3809 4825 3798 4825 3695 C 4825 3568 4832 3551 4924 3435 C 5016 3321 5053 3213 5032 3128 C 5026 3105 5023 3084 5025 3082 C 5027 3079 5058 3106 5094 3142 C 5147 3195 5161 3217 5175 3265 C 5208 3377 5178 3491 5076 3643 C 5005 3748 4983 3806 4970 3920 C 4945 4140 5047 4325 5289 4499 C 5313 4516 5335 4528 5337 4526 C 5340 4524 5330 4505 5317 4483 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 305.81 533.66)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(15,117,188)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-1381.56, -3173.28)",
          d: "M 780 5364 C 717 5353 622 5325 589 5309 C 380 5205 251 4846 183 4185 C 160 3962 160 3363 183 3119 C 270 2196 507 1519 886 1110 C 979 1010 1017 974 1025 981 C 1026 983 1022 1044 1014 1115 C 981 1435 982 2008 1016 2325 C 1079 2920 1221 3338 1461 3636 C 1569 3769 1882 4027 2299 4324 C 2575 4522 2608 4559 2595 4649 C 2589 4689 2579 4703 2516 4765 C 2337 4937 1826 5185 1427 5294 C 1232 5347 1142 5361 970 5365 C 879 5367 794 5367 780 5364 z M 1075 4961 L 1115 4934 L 1113 4829 C 1112 4772 1108 4707 1105 4686 L 1099 4647 L 1269 4654 L 1439 4661 L 1455 4609 C 1469 4561 1469 4551 1454 4500 L 1438 4443 L 1397 4446 C 1374 4448 1297 4451 1226 4454 L 1097 4458 L 1103 4327 C 1107 4254 1113 4066 1116 3909 L 1123 3623 L 1077 3592 C 1052 3574 1029 3560 1025 3560 C 1021 3560 998 3574 973 3591 L 927 3623 L 934 3964 C 937 4152 943 4340 946 4382 L 953 4459 L 869 4455 C 823 4452 746 4448 698 4446 L 610 4441 L 594 4497 C 580 4546 580 4559 592 4604 L 605 4655 L 774 4651 L 942 4647 L 936 4756 C 932 4816 927 4879 925 4896 C 920 4922 925 4930 962 4957 C 1015 4996 1025 4996 1075 4961 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 625.09 765.19)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(15,117,188)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3804.54, -1460.43)",
          d: "M 6035 2622 C 5459 2249 4696 1894 4205 1771 C 3995 1718 3909 1706 3730 1706 C 3581 1706 3552 1709 3425 1738 C 3147 1801 3030 1835 2480 2015 C 2054 2154 1921 2184 1756 2178 C 1627 2173 1585 2157 1526 2088 C 1441 1989 1425 1769 1485 1525 C 1564 1204 1698 920 1890 665 C 1983 541 2141 391 2232 340 C 2523 179 2958 181 3473 347 C 3871 475 4328 718 4655 975 C 4710 1019 4877 1149 5025 1265 C 5418 1571 5521 1655 5655 1777 C 5982 2076 6135 2331 6157 2617 C 6160 2663 6161 2700 6159 2700 C 6157 2700 6101 2665 6035 2622 z M 3452 1551 C 3469 1545 3527 1458 3644 1264 C 3800 1007 3813 982 3811 942 C 3810 913 3816 887 3830 863 C 3841 843 3850 826 3848 825 C 3846 823 3762 810 3662 795 C 3561 781 3472 766 3465 764 C 3445 756 3457 694 3491 633 L 3520 580 L 3495 564 C 3481 555 3463 550 3455 554 C 3433 562 3400 640 3393 700 C 3390 728 3383 750 3378 750 C 3373 750 3348 738 3323 723 C 3284 700 3267 697 3211 699 C 3175 700 3089 702 3020 702 C 2894 703 2832 691 2657 637 L 2609 622 L 2587 658 C 2395 968 2239 1227 2239 1235 C 2239 1241 2248 1246 2260 1248 C 2273 1250 2290 1271 2310 1310 C 2336 1362 2346 1372 2402 1399 C 2552 1472 2729 1479 2917 1419 L 2978 1399 L 3066 1449 C 3208 1531 3384 1577 3452 1551 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 527.83 788.71)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3016.55, -1314.41)",
          d: "M 3011 1320 C 3025 1289 3030 1284 3030 1296 C 3030 1302 3023 1315 3014 1326 C 3000 1344 3000 1344 3011 1320 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 530.97 795.96)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3040, -1260.22)",
          d: "M 3030 1275 C 3030 1270 3035 1258 3040 1250 C 3045 1242 3050 1240 3050 1245 C 3050 1251 3045 1262 3040 1270 C 3035 1278 3030 1281 3030 1275 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 459.65 837.69)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-2511.15, -940.37)",
          d: "M 2260 1229 C 2260 1224 2303 1148 2356 1062 C 2478 864 2612 646 2614 643 C 2615 642 2651 652 2695 665 C 2739 678 2769 689 2761 689 C 2753 690 2720 683 2688 674 C 2656 665 2628 659 2626 661 C 2624 663 2545 794 2450 953 C 2293 1214 2260 1261 2260 1229 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 534.29 803.93)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3065, -1200.21)",
          d: "M 3051 1225 C 3051 1220 3057 1204 3065 1190 C 3073 1176 3079 1170 3079 1175 C 3079 1181 3073 1196 3065 1210 C 3057 1224 3051 1231 3051 1225 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 539.62 815.93)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3105, -1110.21)",
          d: "M 3091 1135 C 3091 1130 3097 1114 3105 1100 C 3113 1086 3119 1080 3119 1085 C 3119 1091 3113 1106 3105 1120 C 3097 1134 3091 1141 3091 1135 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 543.62 825.27)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3135, -1040.21)",
          d: "M 3121 1065 C 3121 1060 3127 1044 3135 1030 C 3143 1016 3149 1010 3149 1015 C 3149 1021 3143 1036 3135 1050 C 3127 1064 3121 1071 3121 1065 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 549 838.23)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3175.49, -942.4)",
          d: "M 3154 990 C 3163 958 3193 889 3197 893 C 3199 896 3189 922 3175 951 C 3161 981 3152 998 3154 990 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 554.97 851.96)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3220, -840.22)",
          d: "M 3210 855 C 3210 850 3215 838 3220 830 C 3225 822 3230 820 3230 825 C 3230 831 3225 842 3220 850 C 3215 858 3210 861 3210 855 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 608.9 854.74)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3629.08, -819.01)",
          d: "M 3809 856 C 3806 853 3744 846 3670 841 C 3500 827 3430 813 3437 792 C 3442 781 3453 779 3484 784 C 3507 787 3593 800 3677 813 C 3792 830 3827 838 3821 848 C 3817 855 3812 858 3809 856 z",
          strokeLinecap: "round"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { transform: "matrix(0.13 0 0 -0.13 553.43 864.38)", children: /* @__PURE__ */ jsx(
        "path",
        {
          style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1
          },
          vectorEffect: "non-scaling-stroke",
          transform: " translate(-3212.5, -746.82)",
          d: "M 3307 749 C 3252 721 3245 719 3199 729 C 3171 735 3126 740 3097 739 L 3045 738 L 3090 727 C 3115 721 3170 716 3212 715 C 3276 715 3293 719 3319 738 C 3336 750 3356 760 3365 760 C 3373 760 3380 765 3380 770 C 3380 785 3371 782 3307 749 z",
          strokeLinecap: "round"
        }
      ) })
    ]
  }
);
var acts_logo_default = ActsLogo;
var Sidebar = (props) => {
  const {
    menuConfig,
    user,
    logout,
    authUrl,
    hideLanguageSwitcher,
    hideAppNavigator,
    currentApp,
    appUrls
  } = props;
  const {
    isWide,
    theme,
    isMobile,
    open,
    setOpen,
    variant,
    isLoggingOut,
    isNavigatingAuth,
    // showMenu,
    handleLogout,
    handleUserClick,
    toggleWidth,
    showDrawer
  } = useSidebarController({ logout, authUrl });
  const [expandedItems, setExpandedItems] = React.useState([]);
  const DrawerHeader = styled("div")(({ theme: theme2 }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme2.spacing(0, 1),
    ...theme2.mixins.toolbar
  }));
  const getDisplayName = (user2) => {
    const fn = user2.first_name || user2.firstName;
    const ln = user2.last_name || user2.lastName;
    if (!fn && !ln) return user2.email || "Unknown User";
    return `${fn || ""} ${ln || ""}`.trim();
  };
  const toggleExpandedItem = (itemKey) => {
    setExpandedItems((currentExpandedItems) => {
      if (currentExpandedItems.includes(itemKey)) {
        return currentExpandedItems.filter((key) => key !== itemKey);
      }
      return [...currentExpandedItems, itemKey];
    });
  };
  const collapsedButtonSx = {
    p: 1,
    justifyContent: isWide ? "initial" : "center"
  };
  const collapsedIconSx = {
    minWidth: isWide ? 56 : 0,
    justifyContent: isWide ? "initial" : "center",
    alignItems: "center",
    display: "flex"
  };
  const getMenuItemColor = (item) => {
    if (item.color) return item.color;
    if (React.isValidElement(item.icon)) {
      const props2 = item.icon.props;
      return props2?.sx?.color || props2?.style?.color || props2?.htmlColor || (props2?.color && props2.color !== "inherit" ? props2.color : void 0);
    }
    return void 0;
  };
  const renderMenuItems = (items, depth = 0) => {
    return items.map((item, itemIndex) => {
      const itemColor = getMenuItemColor(item);
      return /* @__PURE__ */ jsxs(React.Fragment, { children: [
        /* @__PURE__ */ jsx(ListItem, { disablePadding: true, children: item.children ? /* @__PURE__ */ jsxs(
          ListItemButton,
          {
            onClick: (event) => {
              event.preventDefault();
              toggleExpandedItem(item.key);
            },
            sx: collapsedButtonSx,
            children: [
              /* @__PURE__ */ jsx(
                ListItemIcon,
                {
                  title: item.label,
                  "aria-label": item.label,
                  sx: {
                    ...collapsedIconSx,
                    color: itemColor || (item.to === "" ? "#1976d2" : void 0)
                  },
                  children: isWide ? item.icon : !expandedItems.includes(item.key) ? item.icon : /* @__PURE__ */ jsx(ExpandLessIcon, {})
                }
              ),
              /* @__PURE__ */ jsx(
                ListItemText,
                {
                  primary: item.label,
                  sx: { display: isWide ? "block" : "none" }
                }
              ),
              isWide && (expandedItems.includes(item.key) ? /* @__PURE__ */ jsx(ExpandLessIcon, {}) : /* @__PURE__ */ jsx(ExpandMoreIcon, {}))
            ]
          }
        ) : /* @__PURE__ */ jsxs(
          ListItemButton,
          {
            component: Link,
            to: item.to || "#",
            sx: collapsedButtonSx,
            children: [
              /* @__PURE__ */ jsx(
                ListItemIcon,
                {
                  title: item.label,
                  "aria-label": item.label,
                  sx: {
                    ...collapsedIconSx,
                    color: itemColor || (item.to === "" ? "blue" : void 0)
                  },
                  children: item.icon
                }
              ),
              /* @__PURE__ */ jsx(
                ListItemText,
                {
                  primary: item.label,
                  sx: { display: isWide ? "block" : "none" }
                }
              )
            ]
          }
        ) }),
        item.children && /* @__PURE__ */ jsx(
          Collapse,
          {
            in: expandedItems.includes(item.key),
            timeout: "auto",
            children: /* @__PURE__ */ jsx(List, { sx: { pl: 0 }, children: renderMenuItems(item.children, depth + 1) })
          }
        ),
        item.divider
      ] }, `${item.key}-C${itemIndex}`);
    });
  };
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    isMobile && /* @__PURE__ */ jsx(
      IconButton,
      {
        onClick: showDrawer,
        sx: {
          position: "absolute",
          top: 8,
          left: 8,
          backgroundColor: "white"
        },
        children: /* @__PURE__ */ jsx(DehazeIcon, {})
      }
    ),
    /* @__PURE__ */ jsxs(
      Drawer,
      {
        variant: isMobile ? "temporary" : variant,
        sx: {
          width: isWide ? 240 : 64,
          flexShrink: 0,
          overflowX: "hidden",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
          }),
          "& .MuiDrawer-paper": {
            width: isWide ? 240 : 64,
            boxSizing: "border-box",
            overflowX: "hidden",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            })
          }
        },
        open,
        onClose: () => setOpen(false),
        children: [
          /* @__PURE__ */ jsxs(DrawerHeader, { children: [
            /* @__PURE__ */ jsx(
              Avatar,
              {
                sx: {
                  width: 40,
                  height: 40,
                  display: isWide ? "block" : "none",
                  p: 0,
                  backgroundColor: "transparent"
                },
                children: /* @__PURE__ */ jsx(acts_logo_default, { width: "100%", height: "100%" })
              }
            ),
            /* @__PURE__ */ jsx(IconButton, { onClick: toggleWidth, children: /* @__PURE__ */ jsx(MenuIcon, {}) })
          ] }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(List, { children: renderMenuItems(menuConfig) }),
          /* @__PURE__ */ jsxs(List, { sx: { mt: "auto" }, children: [
            !hideAppNavigator && /* @__PURE__ */ jsx(
              AppSwitcher_default,
              {
                variant: "sidebar",
                isWide,
                currentApp,
                appUrls: appUrls ? { auth: authUrl, ...appUrls } : authUrl ? { auth: authUrl } : void 0
              }
            ),
            !hideLanguageSwitcher && /* @__PURE__ */ jsx(LanguageSwitcher_default, { variant: "sidebar", isWide }),
            user && /* @__PURE__ */ jsx(ListItem, { disablePadding: true, children: /* @__PURE__ */ jsxs(
              ListItemButton,
              {
                onClick: handleUserClick,
                sx: collapsedButtonSx,
                title: getDisplayName(user),
                children: [
                  /* @__PURE__ */ jsx(ListItemIcon, { sx: collapsedIconSx, children: /* @__PURE__ */ jsx(
                    Avatar,
                    {
                      src: user.photoURL || user_default,
                      alt: getDisplayName(user),
                      sx: {
                        width: 32,
                        height: 32,
                        margin: 0,
                        flexShrink: 0
                      }
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    ListItemText,
                    {
                      primary: getDisplayName(user),
                      secondary: user.email,
                      sx: { display: isWide ? "block" : "none" }
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ jsx(ListItem, { disablePadding: true, children: /* @__PURE__ */ jsxs(ListItemButton, { onClick: handleLogout, sx: collapsedButtonSx, children: [
              /* @__PURE__ */ jsx(ListItemIcon, { sx: collapsedIconSx, children: /* @__PURE__ */ jsx(LogoutIcon, {}) }),
              /* @__PURE__ */ jsx(
                ListItemText,
                {
                  primary: "Logout",
                  sx: { display: isWide ? "block" : "none" }
                }
              )
            ] }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Backdrop,
      {
        sx: {
          color: "#fff",
          zIndex: (theme2) => theme2.zIndex.drawer + 999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "rgba(0, 0, 0, 0.7)"
        },
        open: isLoggingOut || isNavigatingAuth,
        children: [
          /* @__PURE__ */ jsx(CircularProgress, { color: "inherit" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", component: "div", sx: { fontWeight: 500 }, children: isLoggingOut ? "Logging out..." : "Loading profile..." })
        ]
      }
    )
  ] });
};
var Sidebar_default = Sidebar;

export { Sidebar_default };
//# sourceMappingURL=chunk-LJOVFWYR.mjs.map
//# sourceMappingURL=chunk-LJOVFWYR.mjs.map